import { useMutation, useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

export const getArchivedOkrsQueryKey = ({ startTS, endTS, timelineTag }) => [
  REACT_QUERY_KEYS.archivedOkrs,
  startTS,
  endTS,
  timelineTag,
];

export const getArchivedOKRApi = ({ startTS, endTS, timelineTag }) => {
  const url = endpoints.rabbitGoals.getArchivedOkrs;
  return sendRequest({
    method: 'GET',
    url,
    queryParams: {
      startTS,
      endTS,
      timelineTag,
    },
    credentials: 'include',
  });
};

export const useArchivedOKRQuery = ({ startTS, endTS, timelineTag }) =>
  useQuery(
    getArchivedOkrsQueryKey({ startTS, endTS, timelineTag }),
    () =>
      getArchivedOKRApi({
        startTS,
        endTS,
        timelineTag,
      }).then((res) => res.entity),
    { enabled: Boolean(startTS && endTS && timelineTag), retry: 2 }
  );

export const unarchiveOKRApi = ({ okrId }) => {
  const url = endpoints.rabbitGoals.unarchiveOkr(okrId);
  /* @ts-ignore */
  return sendRequest({
    method: 'POST',
    url,
    credentials: 'include',
  });
};

export const useUnarchiveOKRMutation = (uuid) =>
  useMutation({
    mutationFn: async () =>
      unarchiveOKRApi({
        okrId: uuid,
      }),
  });
